import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import "rxjs/add/operator/pluck";
import "rxjs/add/operator/distinctUntilChanged";

import { Spell } from "./shared/models/spell";

export interface State {
  spells: Spell[];
  [key: string]: any;
}

const STATE: State = {
    spells: undefined
};

export class Store {

  private subject = new BehaviorSubject<State>(STATE);
  private store = this.subject.asObservable().distinctUntilChanged();

  get value() {
    return this.subject.value;
  }

  select<T>(name: string): Observable<T> {
    return this.store.pluck(name);
  }

  set(name: string, state: any) {
    this.subject.next({ ...this.value, [name]: state });
  }

}



// WEBPACK FOOTER //
// ./src/store.ts